// Types
import { CurrencyState } from '../objects/currencyState';
// Action Types
import { CurrencyActionTypes, SET_CONVERT_TO, SET_EXPORT_TYPE, SET_LIMIT, SET_LIST, SET_PAGE, SET_RUNNING, SET_SEARCH, TOGGLE_EXPORT, TOGGLE_EXPORT_FULL, TOGGLE_FILTERS, TOGGLE_REFRESH } from './actionTypes';
// Helpers
import displayedList from '../helpers/displayedList';
import i18next from 'i18next';

const initialState: CurrencyState = {
    convert_to: null,
    count: 0,
    displayed_list: null,
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    filter_open: false,
    limit: 50,
    list: null,
    page: 0,
    refresh: false,
    running: false,
    search: ''
};

export default (state: CurrencyState = initialState, action: CurrencyActionTypes): CurrencyState => {
    switch (action.type) {
        case SET_CONVERT_TO: {
            if (state.list === null) {
                return {...state, convert_to: action.payload};
            }
            let list = [...state.list];
            for (let i = 0; i < list.length; i++) {
                const unit = new Intl.NumberFormat(i18next.language, { style: 'currency', currency: list[i].iso_code, minimumFractionDigits: 0 }).format(
                    1,
                );
                const fractionDigits = Math.max(0, (parseFloat(action.payload.usd_factor) / parseFloat(list[i].usd_factor)).toString().split('.')[1]?.length || 0);
                const value = new Intl.NumberFormat(i18next.language, { style: 'currency', currency: action.payload.iso_code, minimumFractionDigits: fractionDigits }).format(
                    parseFloat(action.payload.usd_factor) / parseFloat(list[i].usd_factor),
                );
                list[i] = {...list[i], factor: `${unit} = ${value}`};
            }
            const { count, displayed_list } = displayedList(list, state.page, state.limit, state.search);
            return {...state, list: list, count: count, displayed_list: displayed_list, convert_to: action.payload};
        }
        case SET_EXPORT_TYPE: {
            return {...state, export_type: action.payload};
        }
        case SET_LIMIT: {
            if (state.list === null) {
                return {...state, limit: action.payload};
            }
            const { count, displayed_list } = displayedList(state.list, 0, action.payload, state.search);
            return {...state, count: count, displayed_list: displayed_list, page: 0, limit: action.payload};
        }
        case SET_LIST: {
            const { results } = action.payload;
            let convert_to = state.convert_to;
            if (convert_to === null) {
                for (let i = 0; i < results.length; i++) {
                    if (results[i].iso_code === 'USD') {
                        convert_to = results[i];
                    }
                    const unit = new Intl.NumberFormat(i18next.language, { style: 'currency', currency: results[i].iso_code, minimumFractionDigits: 0 }).format(
                        1,
                    );
                    const fractionDigits = Math.max(0, 1 / parseFloat(results[i].usd_factor)).toString().split('.')[1]?.length || 0;
                    const value = new Intl.NumberFormat(i18next.language, { style: 'currency', currency: 'USD', minimumFractionDigits: fractionDigits }).format(
                        1 / parseFloat(results[i].usd_factor),
                    );
                    results[i].factor = `${unit} = ${value}`;
                }
            } else {
                for (let i = 0; i < results.length; i++) {
                    const unit = new Intl.NumberFormat(i18next.language, { style: 'currency', currency: results[i].iso_code, minimumFractionDigits: 0 }).format(
                        1,
                    );
                    const fractionDigits = Math.max(0, (parseFloat(convert_to.usd_factor) / parseFloat(results[i].usd_factor))).toString().split('.')[1]?.length || 0;
                    const value = new Intl.NumberFormat(i18next.language, { style: 'currency', currency: convert_to.iso_code, minimumFractionDigits: fractionDigits }).format(
                        parseFloat(convert_to.usd_factor) / parseFloat(results[i].usd_factor) ,
                    );
                    results[i].factor = `${unit} = ${value}`;
                }
            }
            const { count, displayed_list } = displayedList(results, 0, state.limit, state.search);
            return {...state, count: count, page: 0, list: results, convert_to: convert_to, displayed_list: displayed_list, running: false};
        }
        case SET_PAGE: {
            if (state.list === null) {
                return {...state, page: action.payload};
            }
            const { count, displayed_list } = displayedList(state.list, action.payload, state.limit, state.search);
            return {...state, count: count, displayed_list: displayed_list, page: action.payload};
        }
        case SET_RUNNING: {
            return {...state, running: action.payload};
        }
        case SET_SEARCH: {
            if (state.list === null) {
                return {...state, search: action.payload, page: 0};
            }
            const { count, displayed_list } = displayedList(state.list, 0, state.limit, action.payload);
            return {...state, count: count, displayed_list: displayed_list, page: 0, search: action.payload};
        }
        case TOGGLE_EXPORT: {
            return {...state, export_list: action.payload};
        }
        case TOGGLE_EXPORT_FULL: {
            return {...state, export_full: !state.export_full};
        }
        case TOGGLE_FILTERS: {
            return {...state, filter_open: !state.filter_open};
        }
        case TOGGLE_REFRESH: {
            return {...state, refresh: !state.refresh};
        }
        default:
            return state;
    }
};